import { render } from "./ActivationRequiredPage.vue?vue&type=template&id=0610734a"
import script from "./ActivationRequiredPage.vue?vue&type=script&lang=js"
export * from "./ActivationRequiredPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__